import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders, Type } from '@angular/core';

import { COLLECTION_FILTERING_DATA_ADAPTER } from './collection-filtering-data-adapter.token';
import { CollectionFilteringDataAdapter } from './collection-filtering-data-adapter.interface';

export const provideCollectionFilteringDataAdapter = <DataAdapter extends CollectionFilteringDataAdapter>(
  dataAdapter: Type<DataAdapter> | InjectionToken<DataAdapter>,
): EnvironmentProviders => makeEnvironmentProviders([{ provide: COLLECTION_FILTERING_DATA_ADAPTER, useExisting: dataAdapter }]);
